import { BootstrapData } from '../api/types';
import { asPromise, openDB, STORE_SNAPSHOT, txStore } from './db';

const KEY = 'current';

export async function getSnapshot(): Promise<BootstrapData | null> {
  try {
    const db = await openDB();
    const v = await asPromise(txStore(db, STORE_SNAPSHOT, 'readonly').get(KEY));
    return (v as BootstrapData | undefined) ?? null;
  } catch {
    return null;
  }
}

export async function putSnapshot(data: BootstrapData): Promise<void> {
  const db = await openDB();
  await asPromise(txStore(db, STORE_SNAPSHOT, 'readwrite').put(data, KEY));
}

export async function clearSnapshot(): Promise<void> {
  const db = await openDB();
  await asPromise(txStore(db, STORE_SNAPSHOT, 'readwrite').delete(KEY));
}
